module.exports = "pegasus_template/assets/themelp1/webinar/106.png";